module.exports = __webpack_public_path__ + "img/gt.gt224b126.svg";